module.exports = __webpack_public_path__ + "img/tree.59ecebc1.svg";